import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

// components
import AppRoutes from './Router/AppRoutes';

function App() {
  const { language } = useSelector((state) => state.lang);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return (
    <div className="App d-flex flex-column">
      <Helmet>
        <html lang={language} dir={language === "en" ? "ltr" : "rtl"}></html>
      </Helmet>
      <AppRoutes />
      <ToastContainer />
    </div >
  );
}

export default App;
